export function MsgDeskLoading() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f3f1ec] px-6 text-[#25302d]">
      <div className="rounded-xl border border-[#d7d1c5] bg-white px-6 py-5 shadow-sm">
        <div className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#68746f]">Opening Proof Protocol</div>
        <div className="mt-2 text-sm">Preparing the message record…</div>
      </div>
    </div>
  )
}
